import { Shield, Award, Users, Clock } from "lucide-react";
import { Link } from "react-router-dom";

const trustIndicators = [
  {
    icon: Shield,
    title: "CPO Certified & Insured",
    description: "$1M liability insurance for your peace of mind",
    link: "/cpo-certification"
  },
  {
    icon: Award,
    title: "CPO Certified",
    description: "Certified Pool & Spa Operator by PHTA",
    link: "/cpo-certification"
  },
  {
    icon: Users,
    title: "Many Happy Clients",
    description: "Trusted by pool owners across Southern California",
    link: undefined
  },
  {
    icon: Clock,
    title: "Years of Experience",
    description: "Established and proven track record",
    link: undefined
  }
];

export const TrustBadges = () => {
  return (
    <section className="py-12 bg-luxury/50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {trustIndicators.map((item, index) => {
            const content = (
              <>
                <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <item.icon className="w-8 h-8 text-primary-foreground" />
                </div>
                <h3 className="text-lg font-semibold text-primary mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {item.description}
                </p>
              </>
            );

            return (
              <div key={index} className="text-center group">
                {item.link ? (
                  <Link to={item.link} className="block">
                    {content}
                  </Link>
                ) : (
                  content
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};